import { MembershipRoleEnum } from "@app_schema";

// A clinician only sees cases they own, so a case staff create for nobody is a
// case its clinician never sees. Staff must pick an owner when the org has a
// clinician, and the only one is picked for them. Admins are unchanged.
export const newProjectAssignment = ({
  role,
  memberships,
}: {
  role?: string | null;
  memberships?: ReadonlyArray<{
    role: MembershipRoleEnum;
    user: { id: string };
  }>;
}) => {
  if (role !== "staff") return { required: false, defaultUserId: "" };
  if (!memberships) return { required: true, defaultUserId: "" };

  const clinicians = memberships.filter(
    ({ role }) => role === MembershipRoleEnum.Clinician,
  );

  return {
    required: clinicians.length > 0,
    defaultUserId: clinicians.length === 1 ? clinicians[0].user.id : "",
  };
};
